import { Guid } from "@/types"
import Notification, { IGetNotification } from "./Notification"

export interface IGetNotificationShippingOrderChangedDto extends IGetNotification {
    reservationId: Guid
    reservationNumber?: string
    shippingOrderId?: Guid
    shippingOrderNumber?: string
}

export default class NotificationShippingOrderChanged extends Notification {
    reservationId: Guid
    reservationNumber?: string
    shippingOrderId?: Guid
    shippingOrderNumber?: string

    constructor(dto: IGetNotificationShippingOrderChangedDto) {
        super(dto)
        this.reservationId = dto.reservationId
        this.reservationNumber = dto.reservationNumber
        this.shippingOrderId = dto.shippingOrderId
        this.shippingOrderNumber = dto.shippingOrderNumber
    }
}
